(function(){
	'strict';

	const $ = jQuery;

    let btnConfirmMigrateDatabase   = $( '#btn-confirm-migrate-database' ),
        confirmationModal           = $( '#modal-confirm-migrate-database' ),
        confirmationInput           = confirmationModal.find( '.input-confirmation '),
        progressModal               = $( '#modal-progress-migrate-database' ),
        progressBar1                = progressModal.find( '.progress-bar-1'),
        progressBar2                = progressModal.find( '.progress-bar-2'),
        progressMessage1            = progressModal.find( '.progress-message-1' ),
        progressMessage2            = progressModal.find( '.progress-message-2' ),
		eventSource                 = null,
		migrateDatabaseCalback      = null;

    confirmationInput.on( 'input', function() {
        let val = $( this ).val().trim().toLowerCase();

        btnConfirmMigrateDatabase.attr( 'disabled', val != 'i agree' );
        if ( 'i agree' == val ) {
            btnConfirmMigrateDatabase.focus();
        }
    });

    btnConfirmMigrateDatabase.on( 'click', function() {
        confirmationModal.modal( 'hide' );
        progressModal.modal({
            backdrop: 'static',
            keyboard: false
        });

		migrateDatabaseCalback();
    });

    function updateProgress( id, progress, message ) {
        console.log(message);
        if ( '1' == id ) {
            progressBar1.css( 'width', ( progress * 100 ) + '%' );
            progressMessage1.text( message );
        }
        if ( '2' == id ) {
            progressBar2.css( 'width', ( progress * 100 ) + '%' );
            progressMessage2.text( message );
        }
    }

	function resetData() {
		this.migration_tables = [];
		this.migration_table_count = 0;
		this.migrationUrl = null;
		this.sinceDate = null;
		this.sinceTime = null;
		this.mode = 'fresh';
	}

	Vue.component('db-migration', {
		template: '#v-db-migration',
		props: [],
		data: () => new resetData(),
		store,
		created() {
			this.loadInfo();
		},
		methods: {
			loadInfo() {
				this.fetching = true;
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'db_migration_tables_list',
						url: this.$el.querySelector('[name="import_url"]').value || null,
					},
					onSuccess : function({ data }) {
						_this.migration_tables = data;
						_this.migration_table_count = data.length;
					},
					onError : function( response ) {
						alert( 'Could not load DB migration table list.' );
					},
					onComplete : function() {
						_this.fetching = false;
					},
				});
			},
			resetData,
			onShowTab() {
				this.loadInfo();
			},
			getTableNameCheckboxes() {
				return $( this.$el.querySelectorAll('.table-checkbox') );
			},
			selectAll(e){
				e.preventDefault();
				this.getTableNameCheckboxes().prop( 'checked', true );
			},
			clearAll(e){
				e.preventDefault();
				this.getTableNameCheckboxes().prop( 'checked', false );
			},
			getMigrationTableNames() {
				const tableNames = [];
				const selectedCheckboxes = this.getTableNameCheckboxes().filter( function( index, el ) {
					return $( el ).is( ':checked' );
				})
				selectedCheckboxes.each( function( index, el ) {
					tableNames.push( $( el ).val() );
				});
				return tableNames;
			},
			migrateDatabase(e) {
				e.preventDefault();

				if ( 0 == this.getMigrationTableNames().length ) {
					alert( 'At least one table must be selected for migration!' );
					return;
				}
				migrateDatabaseCalback = this.startMigrateDatabaseTask;
				confirmationModal.modal();
				confirmationInput.focus();
			},
			startMigrateDatabaseTask() {
				const tableNames = this.getMigrationTableNames();
				let urlString = '',
					eventSourceUrl;

				$.each( tableNames, function( index, el) {
					urlString += '&tblName[]=' + el;
				});

				const modeNode = this.$el.querySelector('[name="mode"]:checked');
				if ( modeNode ) {
					urlString += '&mode=' + encodeURIComponent(modeNode.value);
				}

				const migrationUrl = this.$el.querySelector('[name="import_url"]').value;
				if ( '' != migrationUrl ) {
					urlString += '&import_url=' + encodeURIComponent(migrationUrl);
				}

				const sinceDate = this.$el.querySelector('[name="sinceDate"]').value;
				const sinceTime = this.$el.querySelector('[name="sinceTime"]').value;
				if ( '' != sinceDate || '' != sinceTime ) {
					urlString += '&since=' + encodeURIComponent( (sinceDate + ' ' + sinceTime).trim() );
				}
				console.log(this);

				eventSourceUrl = ajax_object.ajax_url + '?action=migrate_database&session_id=' + encodeURIComponent(ajax_object.session_id) + urlString;

				eventSource = new EventSource( eventSourceUrl );

				updateProgress( '1', 0, 'Migrating Database' );

				//a message is received
				const _this = this;
				eventSource.addEventListener( 'message', function(e) {
					var result = JSON.parse( e.data );
					console.log(result);

					if ( e.lastEventId == '1' || e.lastEventId == '2' ) {
						updateProgress( e.lastEventId, result.progress, result.message );
					}

					if ( e.lastEventId == 'CLOSE') {
						eventSource.close();
						progressModal.modal( 'hide' );
						_this.$emit( 'completed', this )
					}

					if ( e.lastEventId == 'ERROR') {
						progressMessage1.text( result.message );
						eventSource.close();
					}
				});

				eventSource.addEventListener('error', function(e) {
					progressMessage1.text( 'An error occurred: No additional information was provided by the server.' );
					eventSource.close();
				});
			},
		},
		watch: {
			migrationUrl() {
				this.loadInfo(this.migrationUrl);
			},
		},
	});
})();
